import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonCard, IonCardContent, IonCol, IonGrid, IonIcon, IonRow } from '@ionic/vue'
import { informationCircleOutline, informationCircleSharp } from 'ionicons/icons'


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoCardComponent',
  setup(__props) {

const infoIcon = { ios: informationCircleOutline, md: informationCircleSharp }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCardContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), { class: "ion-no-padding" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), { class: "ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), { size: "2" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_unref(IonIcon), {
                          slot: "start",
                          style: {"font-size":"35px"},
                          ios: infoIcon.ios,
                          md: infoIcon.md
                        }, null, 8, ["ios", "md"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonCol), { size: "10" }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})